import { render, staticRenderFns } from "./MediaItem.vue?vue&type=template&id=1e026463&scoped=true&"
import script from "./MediaItem.vue?vue&type=script&lang=ts&"
export * from "./MediaItem.vue?vue&type=script&lang=ts&"
import style0 from "./MediaItem.vue?vue&type=style&index=0&id=1e026463&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e026463",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e026463')) {
      api.createRecord('1e026463', component.options)
    } else {
      api.reload('1e026463', component.options)
    }
    module.hot.accept("./MediaItem.vue?vue&type=template&id=1e026463&scoped=true&", function () {
      api.rerender('1e026463', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/MediaItem.vue"
export default component.exports